module.exports = __webpack_public_path__ + "img/add.35e42a85.svg";